import { MprcButton, MprcButtonProps } from "components/MprcButton";
import * as React from "react";
import { useMprcTheme } from "../MprcThemeProvider";

export const ButtonContinue: React.FC<MprcButtonProps> = ({ text, title, color = "info", ...rest }) => {
    const { theme } = useMprcTheme();
    const lText = text || theme.buttons.ButtonContinue.text;
    const lTitle = title || theme.buttons.ButtonContinue.title;
    return (
        <MprcButton
            {...rest}
            color={color}
            title={lTitle}
            text={lText}
        />
    );
};
